import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../core/pages/HomePage';
import LandingPage from '../core/pages/LandingPage';
import BoatPage from '../core/pages/BoatPage';
import AboutUsPage from '../core/pages/AboutUsPage';
import ServicesPage from '../core/pages/ServicesPage';
import ContactPage from '../core/pages/ContactPage'
import FAQsPage from '../core/pages/FAQsPage';
import TermsPage from '../core/pages/TermsPage';
import PrivacyPolicyPage from '../core/pages/PrivacyPolicy';
import UserLoginPage from '../users/pages/customuser/UserLoginPage';
import UserSignUpPage from '../users/pages/customuser/UserSignUpPage';
import UserEmailVerificationPage from '../users/pages/customuser/UserEmailVerificationPage';
import UserAccountPage from '../users/pages/customuser/UserAccountPage';
import UserForgotPasswordPage from '../users/pages/customuser/UserForgotPasswordPage';
import UserResetPasswordConfirmPage from '../users/pages/customuser/UserResetPasswordConfirmPage';
import ProtectedRouteUserAuth from './ProtectedRouteUserAuth';

// Blog pages
import BlogPage from '../blog/pages/BlogPage';
import BlogPostPage from '../blog/pages/BlogPostPage';

// 404 page
import NotFoundPage from '../core/pages/NotFoundPage';

const CoreRouter = () => (
  <Routes>
    <Route path="" element={<HomePage />} />
    <Route path="experience" element={<LandingPage />} />
    <Route path="about-us" element={<AboutUsPage />} />
    <Route path="services" element={<ServicesPage />} />
    <Route path="boats/:id/:name/" element={<BoatPage />} />
    <Route path="faqs-page" element={<FAQsPage />} />
    <Route path="terms" element={<TermsPage />} />
    <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
    
    {/* Blog routes */}
    <Route path="blog" element={<BlogPage />} />
    <Route path="blog/:slug" element={<BlogPostPage />} />
    
    {/* 404 catch-all route - must be last */}
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

export default CoreRouter;